import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import { message } from 'antd';
import SlideBar from './components/SlideBar';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { likeProfile, unlikeProfile } from '../ListView/redux/slice';
import { send_request_list, short_list } from '../ProfileView/redux/slice';
// import { respondActions } from '../ProfileView/redux/slice';
// import { get_profile_view } from '../ProfileView';
// import { useSelector } from 'react-redux';
import {
  countryCodes,
  occupationData,
  maritialStatus,
  familyStatus,
  familyValue,
  familyType,
  siblings_maritial_Status,
  hobbies_list,
  sports_list,
  education_list,
  department_list,
  cities_list,
  stateCodes,
  currencyCodes,
  get_searchResult
} from '../Search/redux/slice';
// '../EditEducationsDetails/redux/slice';

const index = () => {
  // const { search_details } = useSelector((state) => state.searchresults);
  const location = useLocation();
  const dispatch = useDispatch();
  const searchData = location.state?.data;

  const { country_codes, city_details, education_details, department_details } =
    useSelector((state) => state.registrations);
  const { state_details } = useSelector((state) => state.editeducation);
  const { searchResult_loading } = useSelector((state) => state.searchresults);

  useEffect(() => {
    get_countryCodes();
    get_occupation();
    get_maritialStatus();
    get_familyStatus();
    get_familyValue();
    get_familyType();
    get_siblings_maritialStatus();
    get_hobbies();
    get_sports();
    get_education_details();
    get_department_details();
    get_cities();
    get_states();
    get_currency();
  }, []);

  const get_countryCodes = () => {
    dispatch(countryCodes());
  };

  const get_states = () => {
    dispatch(stateCodes());
  };

  const get_cities = () => {
    dispatch(cities_list());
  };

  const get_occupation = () => {
    dispatch(occupationData());
  };
  const get_maritialStatus = () => {
    const payload = { type: 'user' };
    dispatch(maritialStatus(payload));
  };
  const get_familyStatus = () => {
    dispatch(familyStatus());
  };
  const get_familyValue = () => {
    dispatch(familyValue());
  };
  const get_familyType = () => {
    dispatch(familyType());
  };
  const get_siblings_maritialStatus = () => {
    dispatch(siblings_maritial_Status());
  };
  const get_hobbies = () => {
    const payload = { type: 'hobby' };
    dispatch(hobbies_list(payload));
  };
  const get_sports = () => {
    const payload = { type: 'sport' };
    dispatch(sports_list(payload));
  };
  const get_education_details = () => {
    dispatch(education_list());
  };
  const get_department_details = () => {
    dispatch(department_list());
  };

  const get_currency = () => {
    dispatch(currencyCodes());
  };

  console.log('Received Payload:', searchData);

  const handleLikeAction = async (profileId, actionType) => {
    console.log(
      'Profile ID:',
      profileId,
      'Action:',
      actionType
      // 'Source Type:',
      // sourceType
    );
    let payload = { profile_id: profileId };

    try {
      const response =
        actionType === 'like'
          ? await dispatch(likeProfile(payload)).unwrap()
          : await dispatch(unlikeProfile(payload)).unwrap();

      if (response?.success) {
        message.success(
          response.message || (actionType === 'like' ? 'Liked!' : 'Unliked!')
        );

        // Refresh data after the action
        // fetchTabData(activeTab);
        // handlegetAIData();
        // if (sourceType === 'aiData') {
        //   handlegetAIData();
        // } else {
        //   fetchTabData(activeTab);
        // }
      }
    } catch (error) {
      console.error('Error in profile action:', error);
      message.error(error?.message || 'Failed to perform action.');
    }
  };

  const handleProfileAction = async (data) => {
    // console.log('Data from UserView:', data);

    if (data.action === 'send_request') {
      const payload = { request_to_profile_id: data.profile_id };
      dispatch(send_request_list(payload));
    } else if (data.action === 'short_profile') {
      const payload = { shortlisted_profile_id: data.profile_id };
      dispatch(short_list(payload));
    }
  };

  // const get_profile_view = (payload) => {
  //   // const payload = params.id;
  //   console.log('Payload1234:', payload);
  //   dispatch(get_by_profileView(payload?.requestor_profile_id));
  // };

  // const handleRequestAction = async (status, profileId) => {
  //   // console.log('status', status);
  //   const payload = {
  //     requestor_profile_id: profileId,
  //     response_type: status
  //   };
  //   // console.log('payload', payload);
  //   // const result =
  //   await dispatch(respondActions(payload)).unwrap();
  //   // console.log('Shortlist Response:', result);
  //   await dispatch(get_profile_view(payload)).unwrap();
  // };

  return (
    <>
      <Layout sider={true}>
        <SlideBar
          searchData={searchData}
          city_details={city_details}
          state_details={state_details}
          country_codes={country_codes}
          education_list={education_details}
          department_details={department_details}
          get_searchResult={get_searchResult}
          onProfileAction={handleLikeAction}
          onSubmit={handleProfileAction}
          searchResult_loading={searchResult_loading}
          // handleRequestAction={handleRequestAction}
        />
      </Layout>
    </>
  );
};

export default index;
